export default __webpack_public_path__ + "static/media/47SA522_47VK61.c7d82bd5.png";